import {
    memberGetAllRewardsBalances,
    getMemberRewardBalanceByCurrency,
} from './rewardsBalance.service';
import { RewardsBalanceAction, RewardsBalanceActionTypes } from './rewardsBalanceActionType';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../../app/reduxRootState.interface';
import { IRewardsBalanceResponse } from '../../rewardsClub.interface';
import { ErrorResolution } from '../../../../app/common/errorResolution/errorResolution';
import { IClientConfig } from '../../../../config/clientConfig';

const initializePageState = () => ({
    type: RewardsBalanceActionTypes.LOADING_CASHBACK_AND_POINTS_PAGE,
});

function getRewardsBalances(
    showCashBack: boolean | undefined,
    pointCurrency?: string | null,
    cashbackCurrency?: string | null | undefined,
) {
    return async (
        dispatch: ThunkDispatch<IReduxRootState, {}, RewardsBalanceAction>,
        getState: () => IReduxRootState,
    ) => {
        dispatch(request());
        try {
            showCashBack = showCashBack ?? false;
            const rewardsBalance: IRewardsBalanceResponse[] = pointCurrency
                ? await getMemberRewardBalanceByCurrency(pointCurrency, cashbackCurrency)
                : await memberGetAllRewardsBalances(showCashBack);
            dispatch(success(rewardsBalance, getState().app.clientConfig));
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request(): RewardsBalanceAction {
        return { type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_REQUEST };
    }

    function success(
        rewardsBalance: IRewardsBalanceResponse[],
        clientConfig: IClientConfig,
    ): RewardsBalanceAction {
        return {
            type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_SUCCESS,
            rewardsBalanceResponse: rewardsBalance,
            clientConfig,
            meta: {
                rat: {},
            },
        };
    }

    function failure(error: ErrorResolution): RewardsBalanceAction {
        return { type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_FAILURE, error };
    }
}

export const rewardsBalanceActions = {
    getRewardsBalances,
    initializePageState,
};
